import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { User } from '../core/models/users.model';

/**
 * Iniciar sesión
 * @param http HttpClient instance
 * @param email User email
 * @param password User password
 * @returns Observable<User>
 */
export function loginApi(
  http: HttpClient,
  email: string,
  password: string
): Observable<User> {
  const url = `${environment.URL_API}/login`;
  return http.post<User>(url, { email, password });
}

/**
 * Petición de cambio de contraseña
 * @param http HttpClient instance
 * @param email User email
 * @returns Observable<any>
 */
export function forgotPasswordApi(
  http: HttpClient,
  email: string
): Observable<any> {
  const url = `${environment.URL_API}/auth/forgot-password`;
  return http.post<any>(url, { email });
}

/**
 * Establecer nueva contraseña
 * @param http HttpClient instance
 * @param token User token
 * @param newPassword New password
 * @param changeToken optional change token (user exists on other tenant) only send if not empty
 * @returns Observable<any>
 */
export function setNewPasswordApi(
  http: HttpClient,
  token: string,
  newPassword: string,
  changeToken?: string
): Observable<any> {
  const url = `${environment.URL_API}/auth/set-new-password`;
  return http.patch<any>(url, {
    token,
    newPassword,
    changeToken: changeToken ?? '',
  });
}
